import type {Question} from '@cp/model';
import {questionUserFlag} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useFlagQuestionAsOutOfScope() {
  const {
    fn: flagQuestionAsOutOfScope,
    loading,
    error,
  } = useFunctionWrap(
    async (moduleId: string, questionId: string, statusNote?: string): Promise<Question> =>
      questionUserFlag({moduleId, questionId, kind: 'out_of_scope', statusNote}) as Promise<Question>,
  );

  return {
    flagQuestionAsOutOfScope,
    loading,
    error,
  };
}
